import sentry from '@/3rd-parties/sentry'

export function setWithExpiry(key, value, ttl) {
  try {
    const now = new Date()

    // `item` is an object which contains the original value
    // as well as the time when it's supposed to expire
    const item = {
      value,
      expiry: now.getTime() + ttl,
    }
    localStorage.setItem(key, JSON.stringify(item))
  } catch (e) {
    sentry.captureException(e)
  }
}

export function getWithExpiry(key) {
  try {
    const itemStr = localStorage.getItem(key)
    // if the item doesn't exist, return null
    if (!itemStr) {
      return null
    }
    const item = JSON.parse(itemStr)
    const now = new Date()
    // compare the expiry time of the item with the current time
    if (item.expiry === undefined || now.getTime() > item.expiry) {
      // If the item is expired, delete the item from storage
      // and return null
      localStorage.removeItem(key)
      return null
    }
    return item.value
  } catch (e) {
    sentry.captureException(e)
    return null
  }
}
